import { useState } from "react";
import { useLocation } from "react-router-dom";
import { MailWarning, X } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { useLang } from "@/context/LangContext";
import { useResendVerification } from "@/components/VerifyEmailSheet";

export default function VerifyEmailBanner() {
  const { user } = useAuth();
  const { t } = useLang();
  const loc = useLocation();
  const [hidden, setHidden] = useState(() => sessionStorage.getItem("auk_verify_banner_dismissed") === "1");
  const { resend, cooldown, busy } = useResendVerification();
  if (!user || user.email_verified !== false || hidden || loc.pathname.startsWith("/verificar-email")) return null;
  const dismiss = () => { sessionStorage.setItem("auk_verify_banner_dismissed", "1"); setHidden(true); };
  return (
    <div data-testid="verify-banner" className="bg-[#fff8d6] border-b border-[#f3e4a0] text-[12px] text-zinc-800">
      <div className="max-w-5xl mx-auto px-4 py-2 flex items-center gap-2">
        <MailWarning size={14} className="text-[#c8102e] shrink-0" />
        <span className="flex-1 min-w-0 truncate">{t("verify_banner")}</span>
        <button onClick={resend} disabled={busy || cooldown > 0} data-testid="verify-banner-resend"
                className="font-bold underline disabled:opacity-50 shrink-0">
          {cooldown > 0 ? `${cooldown}s` : t("verify_resend")}
        </button>
        <button onClick={dismiss} data-testid="verify-banner-dismiss" className="p-0.5 rounded hover:bg-black/5 shrink-0" aria-label="close"><X size={14} /></button>
      </div>
    </div>
  );
}
